import { apiSlice } from "../../../api/ApiService";
import { AppDispatch } from "../../../store/store";
import { getHeadersFromRedux } from "../../../utility/functions/common-functions";

const getLearningLibraryApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLearningLibraryContentApi: builder.query({
      query: ({
        patientProfileId,
        body,
        lang,
      }: {
        patientProfileId: number;
        lang: string;
        body : any;
      }) => {
        const headers = getHeadersFromRedux();
        headers["X-Language"] = lang;
        return {
          url: `/api/v1/Patient/${patientProfileId}/education-library`,
          method: "POST",
          data: body,
          headers,
        };
      },
      // Associate this query with a tag
      providesTags: (result, error, { patientProfileId, lang }) => [
        { type: "LearningLibraryContent", id: `${patientProfileId}-${lang}` },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useGetLearningLibraryContentApiQuery } = getLearningLibraryApi;

export const invalidateMyLearningLibrary = (
  dispatch: AppDispatch,
  patientProfileId: number,
  lang: string
) => {
  dispatch(
    apiSlice.util.invalidateTags([
      { type: "LearningLibraryContent", id: `${patientProfileId}-${lang}` },
    ])
  );
};

export default getLearningLibraryApi;

